module.exports = __webpack_public_path__ + "img/bg-cap.252d0443.png";